<div class="flex-column flex-fill">
  <app-header [title]="'Default Rig Teams'" class="flex-item" [loading]="loading">
    <button type="button" kendoButton class="corneredbutton me-1" [disabled]="editedRigs.size <= 0" themeColor="primary" (click)="saveChanges()">Save</button>
    @if (editedRigs.size > 0) {
      <button type="button" kendoButton themeColor="primary" class="me-1" (click)="cancelEdit()">Cancel</button>
    }
  </app-header>
  <ag-grid-angular #agGrid style="height: 100%;" class="ag-theme-balham" (gridReady)="onGridReady($event)"
    [gridOptions]="projectTeamRigsGridOptions" (cellValueChanged)="onCellValueChanged($event)" (rowEditingStopped)="onRowEditStopped($event)">
  </ag-grid-angular>
</div>